<template>
  <!-- LOAD TO SSPOIN -->
  <!-- v-if="akses_sspoint == true" -->
  <!-- style="margin-top: 5px" -->
  <div v-if="!block_sspoint">
    <vs-chip
      v-if="windowWidth >= 1200"
      v-show="role == 3 || role == 4 || akses_sspoint === true"
      style="background: transparent"
    >
      <img
        src="@/assets/images/sspoin/sspoin_logo.png"
        style="width: 30px; cursor: pointer"
        @click="goToSspoin"
      />
      <span
        style="margin-left: 5px; font-size: 13px; cursor: pointer"
        @click="goToSspoin"
        >{{ point }} SSPOIN</span
      >
    </vs-chip>

    <img
      v-else
      v-show="role == 3 || role == 4"
      src="@/assets/images/sspoin/sspoin_logo.png"
      style="width: 26px; cursor: pointer; margin-right: 9px"
      @click="goToSspoin"
    />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      privilege: [
        '',
        'Super Administrator',
        'Administrator',
        'Admin Cabang',
        'General User',
        'Dispatcher',
        'Limited User'
      ],
      actor: '',
      role: -1,
      urlSSPoint: '',
      token: '',
      point: 0,
      list_akses: ['shafira', 'kindy.islamiatti', 'edi.suryadi'],
      akses_sspoint: false,
      block_sspoint: false
    }
  },

  created() {
    this.role =
      localStorage.getItem('userInfo') !== null
        ? this.privilege.indexOf(
            JSON.parse(localStorage.getItem('userInfo')).privilege
          )
        : -1

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.actor =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo'))
        : ''

    this.urlSSPoint = this.$api.sspoin
    this.block_sspoint = this.actor.block_sspoin

    this.list_akses.map((item) => {
      if (item === this.actor.username) {
        this.akses_sspoint = true
      }
    })
  },

  computed: {
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },

  mounted() {
    this.getPoint()
  },

  methods: {
    getPoint() {
      this.$http
        .get(`${this.$api.sspoin_host}/history/currentPoint`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.point = res.data.data.current_point
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    goToSspoin() {
      const token = JSON.parse(localStorage.getItem('userInfo')).token
      window.open(`${this.urlSSPoint + '/' + token}`, '_blank')
    }
  }
}
</script>
